( function ( _s ) {
	const categoryTabsClass = '.category-tabs-slider-container';
	const SPLIDE_CDN_URL =
		'https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist/js/splide.min.js';

	// Utility to load external JS dynamically
	function loadScript( src ) {
		return new Promise( ( resolve, reject ) => {
			const script = document.createElement( 'script' );
			script.src = src;
			script.onload = () => resolve();
			script.onerror = () => reject( new Error( `Failed to load script: ${ src }` ) );
			document.head.appendChild( script );
		} );
	}

	// Initialize Splide on the passed element
	window.initializeSplide = function ( el ) {
		const _self = _s( el );
		const defaultConfig = {
			type: 'slide',
			perPage: 5,
			perMove: 1,
			speed: 1000,
			autoHeight: false,
			gap: '8px',
			pagination: false, // Add this line to disable pagination
			breakpoints: {
				1440: { perPage: 4 },
				720: { perPage: 3 },
				540: { perPage: 1 },
			},
		};

		const config = {
			...defaultConfig,
			...JSON.parse( _self.attr( 'data-splide' ) || '{}' ),
		};

		const slideCount = _self.find( '.splide__slide' ).length;
		config.arrows = config.drag = slideCount > 1;

		const splideInstance = new Splide( el, config );
		splideInstance.on( 'mounted', () => {
			_self.addClass( 'is-initialized' );
			splideInstance.refresh();
		} );
		splideInstance.mount();

		if ( config.emitEvents ) {
			config.emitEvents.forEach( evName => {
				splideInstance.on( evName, ( a, b, c ) => {
					_self.trigger( `sp-splide-${ evName }`, {
						newIndex: a,
						prevIndex: b,
						destIndex: c,
					} );
				} );
			} );
		}
	};

	// Initialize all Splide instances in the active category tab
	const initializeSplides = container => {
		container.querySelectorAll( '.category-posts-sliders' ).forEach( el => {
			window.initializeSplide( el );
		} );
	};

	// Create dropdown elements for mobile
	const createDropdownElements = ( container, tabItems ) => {
		const tabsWrapper = container.querySelector( '.tabs-wrapper' );

		// Find active tab
		const activeTab = Array.from( tabItems ).find( tab => tab.classList.contains( 'active' ) );
		const activeTabText = activeTab ? activeTab.textContent.trim() : 'Select Category';

		// Create dropdown toggle
		const dropdownToggle = document.createElement( 'button' );
		dropdownToggle.className = 'dropdown-toggle category-dropdown';
		dropdownToggle.innerHTML = `<span>${ activeTabText }</span>`;
		dropdownToggle.setAttribute( 'aria-expanded', 'false' );

		// Create dropdown menu
		const dropdownMenu = document.createElement( 'div' );
		dropdownMenu.className = 'dropdown-menu';

		// Add tab items to dropdown
		tabItems.forEach( tab => {
			const dropdownItem = document.createElement( 'div' );
			dropdownItem.className = 'dropdown-item';
			dropdownItem.textContent = tab.textContent.trim();
			dropdownItem.setAttribute( 'data-category', tab.getAttribute( 'data-category' ) );

			if ( tab.classList.contains( 'active' ) ) {
				dropdownItem.classList.add( 'active' );
			}

			dropdownMenu.appendChild( dropdownItem );
		} );

		// Insert dropdown elements
		tabsWrapper.insertBefore( dropdownToggle, tabsWrapper.firstChild );
		tabsWrapper.insertBefore( dropdownMenu, dropdownToggle.nextSibling );

		return { dropdownToggle, dropdownMenu };
	};

	// Handle dropdown functionality
	const setupDropdown = ( container, tabItems, dropdownToggle, dropdownMenu ) => {
		// Toggle dropdown
		dropdownToggle.addEventListener( 'click', e => {
			e.preventDefault();
			const isOpen = dropdownMenu.classList.contains( 'show' );

			if ( isOpen ) {
				dropdownMenu.classList.remove( 'show' );
				dropdownToggle.classList.remove( 'active' );
				dropdownToggle.setAttribute( 'aria-expanded', 'false' );
			} else {
				dropdownMenu.classList.add( 'show' );
				dropdownToggle.classList.add( 'active' );
				dropdownToggle.setAttribute( 'aria-expanded', 'true' );
			}
		} );

		// Handle dropdown item clicks
		const dropdownItems = dropdownMenu.querySelectorAll( '.dropdown-item' );
		dropdownItems.forEach( item => {
			item.addEventListener( 'click', e => {
				e.preventDefault();
				const category = item.getAttribute( 'data-category' );

				// Update dropdown toggle text and active state
				dropdownToggle.querySelector( 'span' ).textContent = item.textContent;
				dropdownItems.forEach( i => i.classList.remove( 'active' ) );
				item.classList.add( 'active' );

				// Close dropdown
				dropdownMenu.classList.remove( 'show' );
				dropdownToggle.classList.remove( 'active' );
				dropdownToggle.setAttribute( 'aria-expanded', 'false' );

				// Update tab states
				tabItems.forEach( t => t.classList.remove( 'active' ) );
				const correspondingTab = Array.from( tabItems ).find(
					t => t.getAttribute( 'data-category' ) === category
				);
				if ( correspondingTab ) {
					correspondingTab.classList.add( 'active' );
				}

				// Switch category content
				const categoryPostsContainers = container.querySelectorAll( '.category-posts' );
				categoryPostsContainers.forEach( postsContainer => {
					postsContainer.classList.remove( 'active' );
					postsContainer.style.display = 'none';
				} );

				const selectedCategoryContent = container.querySelector(
					`.category-posts[data-category="${ category }"]`
				);
				if ( selectedCategoryContent ) {
					selectedCategoryContent.classList.add( 'active' );
					selectedCategoryContent.style.display = 'block';
					initializeSplides( selectedCategoryContent );
				}
			} );
		} );

		// Close dropdown when clicking outside
		document.addEventListener( 'click', e => {
			if ( ! container.contains( e.target ) ) {
				dropdownMenu.classList.remove( 'show' );
				dropdownToggle.classList.remove( 'active' );
				dropdownToggle.setAttribute( 'aria-expanded', 'false' );
			}
		} );
	};

	// Tab switch logic
	_s.fn.categoryTabsSlider = function () {
		return this.each( el => {
			const container = el;
			const tabItems = container.querySelectorAll( '.tab-item' );

			// Create dropdown for mobile
			const { dropdownToggle, dropdownMenu } = createDropdownElements( container, tabItems );
			setupDropdown( container, tabItems, dropdownToggle, dropdownMenu );

			// Desktop tab functionality
			tabItems.forEach( tab => {
				tab.addEventListener( 'click', e => {
					e.preventDefault();
					const category = tab.getAttribute( 'data-category' );

					tabItems.forEach( t => t.classList.remove( 'active' ) );
					tab.classList.add( 'active' );

					// Update dropdown toggle text for mobile
					dropdownToggle.querySelector( 'span' ).textContent = tab.textContent.trim();
					const dropdownItems = dropdownMenu.querySelectorAll( '.dropdown-item' );
					dropdownItems.forEach( item => {
						item.classList.toggle(
							'active',
							item.getAttribute( 'data-category' ) === category
						);
					} );

					const categoryPostsContainers = container.querySelectorAll( '.category-posts' );
					categoryPostsContainers.forEach( postsContainer => {
						postsContainer.classList.remove( 'active' );
						postsContainer.style.display = 'none';
					} );

					const selectedCategoryContent = container.querySelector(
						`.category-posts[data-category="${ category }"]`
					);
					if ( selectedCategoryContent ) {
						selectedCategoryContent.classList.add( 'active' );
						selectedCategoryContent.style.display = 'block';
						initializeSplides( selectedCategoryContent );
					}
				} );
			} );

			const activeCategory = container.querySelector( '.category-posts.active' );
			if ( activeCategory ) {
				initializeSplides( activeCategory );
			}
		} );
	};

	// DOM Ready
	_s( document ).ready( () => {
		const categoryTabsContainers = _s( categoryTabsClass );
		if ( categoryTabsContainers.el.length ) {
			loadScript( SPLIDE_CDN_URL )
				.then( () => {
					categoryTabsContainers.categoryTabsSlider();
				} )
				.catch( error => {
					console.error( 'Error loading Splide:', error );
				} );
		}
	} );
} )( window._s );
